import React from 'react'
import {FILTER_TYPES} from "./utils/FilterPanelConstants"
import "./filterpanel.css"
import PropTypes from "prop-types"
import {FilterBy} from "../SampleStore/Helpers-SampleStore"
import {SAMPLE_TYPES_CODES} from "../../utils/constants"
import ContagiousDropdown from "./ContagiousDropdown"

export default class FilterPanel extends React.Component{
	
	static propTypes = {
		reportType: PropTypes.string.isRequired,
		samples: PropTypes.array.isRequired,
		filterSamples: PropTypes.func.isRequired
	}
	
	constructor(props){
		super(props)
		
		this.state = {
			filterByType: FILTER_TYPES.NONE,
			cellAttribute: '',
			filterValue: ''
		}
	}
	
	filterTypeChange(event){
		
		let value = event.target.value
		let filterType, cellAttribute
		
		switch(value){
			case FILTER_TYPES.NONE:
				filterType = value
				cellAttribute = ''
				break
			case FILTER_TYPES.CONTAGIOUS:
				filterType = value
				cellAttribute = ''
				break
			default:
				filterType = FILTER_TYPES.BY_ATTRIBUTE
				cellAttribute = value
		}
		
		this.setState({
			filterByType: filterType,
			cellAttribute: cellAttribute
		}, () => {
			if(filterType === FILTER_TYPES.NONE) {
				this.applyFilter()
			}
		})
	}
	
	changeFilterAttribute(value){
		this.setState({
			cellAttribute: value,
			filterValue: ''
		})
	}
	
	applyFilter(){
		const { filterByType, cellAttribute, filterValue } = this.state
		
		let filteredSamples = this.props.samples
		
		switch(filterByType){
			case FILTER_TYPES.CONTAGIOUS:
				filteredSamples = FilterBy(this.props.samples, cellAttribute, true)
				break
			case FILTER_TYPES.BY_ATTRIBUTE:
				filteredSamples = FilterBy(this.props.samples, cellAttribute, filterValue)
		}
		
		this.props.filterSamples(filteredSamples)
	}
	
	render() {
		
		const { filterByType } = this.state
		
		let changeFilterValueForm = null
		
		switch(filterByType){
			case FILTER_TYPES.CONTAGIOUS:
				changeFilterValueForm = (
					<div className={'filter-form'}>
						<div className={'select-container'}>
							<p>Contagion:</p>
							<ContagiousDropdown
								reportType={this.props.reportType}
								changeFilterAttribute={this.changeFilterAttribute.bind(this)}
							/>
						</div>
						<button
							type={"button"}
							onClick={this.applyFilter.bind(this)}
							className={"filter-button"}
						>Submit</button>
					</div>
				)
				break
			case FILTER_TYPES.BY_ATTRIBUTE:
				
				break
		}
		
		let contagionOption = (this.props.reportType !== SAMPLE_TYPES_CODES.comp &&
			<option value={FILTER_TYPES.CONTAGIOUS}>Contagious Samples</option>
		)
		
		return(
			<form className={"inline-form"}>
				<div className={'select-container'}>
					<p>Filter By:</p>
					<select onChange={this.filterTypeChange.bind(this)} value={this.state.filterByType} name={"filterByType"}>
						<option value={FILTER_TYPES.NONE}>No Filter</option>
						{contagionOption}
					</select>
				</div>
				{changeFilterValueForm}
			</form>
		)
	}
}